<template>
    <div class='y_fw_sales_1'>
        <div class='y_fw_sales_2'>
            <img :src="product_one_banner.img" alt="">
            <div class='y_fw_sales_3 y_product_one_1'>
                <h3></h3>
                <h2>{{product_one_banner.title}}</h2>
                <span></span>
            </div>
        </div>
        <!-- <div class='y_fw_sales_4'>
            <div class='y_fw_sales_8'>
                <div class='y_fw_sales_5'>
                    <div class='y_fw_sales_6'>
                        <img src="../assets/images/icon_4.png" alt="">
                    </div>
                    <div class='y_fw_sales_7'>
                        <router-link :to="{path:'/'}" class="y_product_list_9">首页</router-link>
                        <img src="../assets/images/icon_5.png" alt="">
                        <router-link :to="{path:'/product_list'}" class="y_product_list_9">产品</router-link>
                        <img src="../assets/images/icon_5.png" alt="">
                        <a href="">{{title}}</a>
                    </div>
                </div>
                <div class='y_aboutbw_1'>
                    <p :class='item.id == id?"y_swiper_active":""' v-for="(item,index) in product_list" :key="index" @click="click_to(item.id,item.title)">{{item.title}}</p>
                </div>
            </div>
        </div> -->

        <div class="proa pagefxide" ref="obtain">
            <div class="proaleft">
                <div class="proalm" :class="!isgua? 'idgua1':'idgua2'" >
                    <div class="proaltxt">
                        <h3 class="proalh3"></h3>
                       	<ul class="proalul">
                            <a target="_blank" :class="index > 2 ?' no':''" @click="pro_router(item.id,item.isChain,item.title,item.link)"  v-for="(item,index) in nav_list" :key="index">
                                <h5><i></i>{{item.title}}</h5>
                            </a>
                            <!-- <a target="_blank" class="" href="../../../index/goods/products/cid/21.html">
                                <h5><i></i>精密棒材</h5>
                            </a>
                            <a target="_blank" class="" href="../../../index/goods/products/cid/22.html">
                                <h5><i></i>精密线材</h5>
                            </a>
                            <a target="_blank" class=" no" href="https://www.bodewires.com">
                                <h5><i></i>精密切割丝</h5>
                            </a>
                            <a target="_blank" class=" no" href="https://www.bedra.com/">
                                <h5><i></i>精密细丝(bedra)</h5>
                            </a>
                            <a target="_blank" class=" no">
                                <h5><i></i>新能源</h5>
                            </a>                            -->
                        </ul>
                    </div>
                </div>
            </div>
            <div class="y_product_one_2">
            <!-- 富文本 -->
            <p style="font-size: 25px;margin-bottom: 10px;color:#3a3a3c">{{product_one_banner.title}}</p>
            <div class="y_product_one_3" v-html="product_one_list.details">
                
            </div>
            <!-- 富文本 -->
            <div class="y_product_one_4">
                <!-- y_product_one_5_active 选中 -->

                <a @click="changNav(item.id)" class="y_product_one_5" :class="pro_children_val == item.id? 'y_product_one_5_active':''" v-for="(item,index) in product_one_children_list" :key="index">
                    <div class="y_product_one_6" :style="id == '2' || id == '3'?'height:auto;':''">
                        <img :style="id == '2' || id == '3'?'width:100%;':''" :src="item.img" alt="">
                    </div>
                    <div class="y_product_one_7">
                        <h2>{{item.title}}</h2>
                    </div>
                </a>
            </div>
            <!-- 产品详情 -->
            <div class="y_product_one_8 y_product_one_8_one" :class="pro_child_one_val == '2'?'': 'y_product_one_8_active'" >
                <div class="y_product_one_9" @click="pro_child_one">
                    <div class="y_product_one_10">
                        <h2>{{$t('home.ProductDetails')}}</h2>
                    </div>
                    <div class="y_product_one_11">
                        <img src="../assets/images/icon_82.png" alt="">
                        <img src="../assets/images/icon_81.png" alt="">
                    </div>
                </div>
                <div class="y_product_one_12">
                    <div class="y_product_one_18" v-for="(item,index) in product_one_children_list" :key="index" :id="'y'+item.id">
                        <div class="y_product_one_13">
                            <h2 class="proar1p4th5">{{item.title}}</h2>
                            <div class="y_product_one_22" v-if="item.downloadDtos.length > 0">
                                <div class="y_product_one_23">
                                    <div class="y_product_one_24">
                                        <h2>{{$t('home.bowayalloy')}}</h2>
                                    </div>
                                    <div class="y_product_one_25">
                                        <h2>{{$t('home.designation')}}</h2>
                                        <div class="y_product_one_26">
                                            <h2>{{$t('home.p_usa')}}</h2>
                                            <h2>{{$t('home.p_ur')}}</h2>
                                            <h2>{{$t('home.p_jp')}}</h2>
                                            <h2>{{$t('home.p_cn')}}</h2>
                                        </div>
                                    </div>
                                    <div class="y_product_one_27">
                                        <h2>{{$t('home.wdownload')}}</h2>
                                    </div>
                                </div>
                                <div class="y_product_one_28" v-for="(ele,i) in item.downloadDtos" :key="i">
                                    <router-link :to="{path:'/product_two',query:{id:ele.id}}" class="y_product_one_29">
                                        <div class="y_product_one_30">
                                            <img :src="ele.imgIco" alt="">
                                        </div>
                                        <div class="y_product_one_31">
                                            <div class="y_product_one_32">
                                                <div class="y_product_one_33">
                                                    <img src="../assets/images/icon_79.png" alt="">
                                                </div>
                                                <div class="y_product_one_34">
                                                    <h2>{{ele.companyBrand}}</h2>
                                                </div>
                                            </div>
                                            <div class="y_product_one_39">
                                                <p>{{ele.cnDescribe}}</p>
                                            </div>
                                        </div>
                                    </router-link>
                                    <div class="y_product_one_35">
                                        <p>{{ele.americanStandard}}</p>
                                        <p>{{ele.europeanStandard}}</p>
                                        <p>{{ele.japaneseStandard}}</p>
                                        <p>{{ele.nationalStandard}}</p>
                                    </div>
                                    <div class="y_product_one_36">
                                        <a v-if="ele.fileUrl" :href="ele.fileUrl" target="_blank" class="y_product_one_36" >
                                            <div class="y_product_one_37">
                                                <img src="../assets/images/icon_80.png" alt="">
                                            </div>
                                            <div class="y_product_one_38">
                                                <p>{{$t('home.pdownload')}}</p>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="y_product_one_14 ql-editor" v-html="item.details"></div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 物性表 -->
            <div class="y_product_one_8 y_product_one_8_two" :class="pro_child_two_val == '1'?'': 'y_product_one_8_active'">
                <div class="y_product_one_9" @click="pro_child_two">
                    <div class="y_product_one_10">
                        <h2>{{$t('home.Datasheets')}}</h2>
                    </div>
                    <div class="y_product_one_11">
                        <img src="../assets/images/icon_82.png" alt="">
                        <img src="../assets/images/icon_81.png" alt="">
                    </div>
                </div>
                <div class="y_product_one_12 y_product_one_21">
                    <div class="y_product_one_19" v-for="(item,index) in product_one_wubiao" :key="index">
                        <div class="y_product_one_20">
                            <h2>{{item.title}}</h2>
                        </div>
                        <div class="y_product_one_22">
                            <div class="y_product_one_23">
                                <div class="y_product_one_24">
                                    <h2>{{$t('home.bowayalloy')}}</h2>
                                </div>
                                <div class="y_product_one_25">
                                    <h2>{{$t('home.designation')}}</h2>
                                    <div class="y_product_one_26">
                                        <h2>{{$t('home.p_usa')}}</h2>
                                        <h2>{{$t('home.p_ur')}}</h2>
                                        <h2>{{$t('home.p_jp')}}</h2>
                                        <h2>{{$t('home.p_cn')}}</h2>
                                    </div>
                                </div>
                                <div class="y_product_one_27">
                                    <h2>{{$t('home.wdownload')}}</h2>
                                </div>
                            </div>
                            <div class="y_product_one_28" v-for="(ele,i) in item.downloadDtos" :key="i">
                                <router-link :to="{path:'/product_two',query:{id:ele.id}}" class="y_product_one_29">
                                    <div class="y_product_one_30">
                                        <img :src="ele.imgIco" alt="">
                                    </div>
                                    <div class="y_product_one_31">
                                        <div class="y_product_one_32">
                                            <div class="y_product_one_33">
                                                <img src="../assets/images/icon_79.png" alt="">
                                            </div>
                                            <div class="y_product_one_34">
                                                <h2>{{ele.companyBrand}}</h2>
                                            </div>
                                        </div>
                                        <div class="y_product_one_39">
                                            <p>{{ele.cnDescribe}}</p>
                                        </div>
                                    </div>
                                </router-link>
                                <div class="y_product_one_35">
                                    <p>{{ele.americanStandard}}</p>
                                    <p>{{ele.europeanStandard}}</p>
                                    <p>{{ele.japaneseStandard}}</p>
                                    <p>{{ele.nationalStandard}}</p>
                                </div>
                                <div class="y_product_one_36">
                                    <a v-if="ele.fileUrl" :href="ele.fileUrl" target="_blank" class="y_product_one_36" >
                                        <div class="y_product_one_37">
                                            <img src="../assets/images/icon_80.png" alt="">
                                        </div>
                                        <div class="y_product_one_38">
                                            <p>{{$t('home.pdownload')}}</p>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div v-if="item.children">
                                <div class="" v-for="(titem,i) in item.children" :key="i+'childpro'">
                                    <p class="zflprotitle">{{titem.title}}</p>
                                    <div class="y_product_one_28" v-for="(ele,i) in titem.downloadDtos" :key="i+'child'">
                                        <router-link :to="{path:'/product_two',query:{id:ele.id}}" class="y_product_one_29">
                                            <div class="y_product_one_30">
                                                <img :src="ele.imgIco" alt="">
                                            </div>
                                            <div class="y_product_one_31">
                                                <div class="y_product_one_32">
                                                    <div class="y_product_one_33">
                                                        <img src="../assets/images/icon_79.png" alt="">
                                                    </div>
                                                    <div class="y_product_one_34">
                                                        <h2>{{ele.companyBrand}}</h2>
                                                    </div>
                                                </div>
                                                <div class="y_product_one_39">
                                                    <p>{{ele.cnDescribe}}</p>
                                                </div>
                                            </div>
                                        </router-link>
                                        <div class="y_product_one_35">
                                            <p>{{ele.americanStandard}}</p>
                                            <p>{{ele.europeanStandard}}</p>
                                            <p>{{ele.japaneseStandard}}</p>
                                            <p>{{ele.nationalStandard}}</p>
                                        </div>
                                        <div class="y_product_one_36">
                                            <a v-if="ele.fileUrl" :href="ele.fileUrl" target="_blank" class="y_product_one_36" >
                                                <div class="y_product_one_37">
                                                    <img src="../assets/images/icon_80.png" alt="">
                                                </div>
                                                <div class="y_product_one_38">
                                                    <p>{{$t('home.pdownload')}}</p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 相关解决方案 -->
            <div class="y_product_one_40" v-if="product_one_xiangguan.length > 0">
                <div class="y_product_one_41">
                    <h2>{{$t('home.RelatedSolutions')}}</h2>
                </div>
                <div class="y_product_one_42">
                    <a @click="goxgwz(item.externalLinks,item.link,item.parentId,item.id)" class="y_product_one_43" v-for="(item,index) in product_one_xiangguan" :key="index">
                        <div class="y_product_one_44">
                            <img :src="item.img" alt="">
                        </div>
                        <div class="y_product_one_45"></div>
                        <div class="y_product_one_46">
                            <h2>{{item.parentTitle}}</h2>
                            <div class="y_product_one_47">
                                <img src="../assets/images/icon_47.png" alt="">
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>


<script>

var VueScrollTo = require("vue-scrollto");
export default {
    name: 'fw_salesView', 
    components: {

    },
    data(){
        return {
            id:'',
            title:'',
            product_one_list:'',  //  
            product_one_children_list:'', // 产品详情 列表
            product_one_banner:'',  // 分页banner
            product_list:'',        // 产品列表
            product_one_wubiao:'',  // 物表性
            product_one_xiangguan:'', // 相关解决方案

            pro_children_val:'',
            pro_child_one_val:'1', //产品详情 打开关闭
            pro_child_two_val:'2', //物性表 打开关闭

            nav_list:[],
            isgua: false,
            isFirstEnter: false
        }
    },
    computed: {
        
    },
    // created() {
    //     this.$get(this.apiUrl + 'home/productPage/productIndex').then((response) => {
    //         this.nav_list =  response.data.portalProductFamilies;
    //     });
    // },
    destroyed(){
        window.removeEventListener("scroll", this.handleScrollx,true);
    },
    mounted() {
        window.addEventListener('scroll', this.handleScrollx, true)
    },
    methods: {
        goxgwz(type,link,id,wzid){
            if(type == 1){
                window.open(link,'_blank');
            }else{
                this.$router.push({
                    path:'/solutions_xq',
                    query:{
                        id:id,
                        wzid:wzid
                    }
                })
            }
        },
        handleScrollx() {
        //   console.log('滚动高度', window.pageYOffset)
        //   console.log('距离顶部高度', this.$refs.obtain.getBoundingClientRect().top)
          if(this.$refs.obtain.getBoundingClientRect().top < 75){
            this.isgua = true
          }else{
            this.isgua = false
          }
        //   this.$once("hook: beforeDestroy", () => {
        //     this.$refs.obtain.removeEventListener("scroll", this.loadMore);
        //     });
        },
        pro_router(id,isChain,title,link){
            if(isChain == 1){
                // window.location.href = link
                window.open(link, '_blank');
            }else{
                // this.$router.push({
                //     path:'/product_one',
                //     query:{
                //         id:id,
                //         title:title,
                //     }
                // })
                let routeData = this.$router.resolve({
                    path: "/product_one",
                    query:{
                        id:id,
                        title:title,
                    }
                });
                window.open(routeData.href, '_blank');
                
            }
       },
        changNav(index) {
            this.pro_child_one_val = '1'
            console.log(index)
            setTimeout(()=>{
                this.navigation = index
                //that.navigation = '1'
                VueScrollTo.scrollTo(document.getElementById("y"+index ), 1000, {
                    offset: -140,
                });
            },0)
        },
        click_to(id,title){
            // alert(id)
            this.id = id;
            this.title = title
            this.$post(this.apiUrl + 'home/productPage/details',{id:id,title:title}).then((response) => {
                // this.product_one_children_list = response.data.children
                // this.product_one_list =  response.data;
                // this.product_one_banner =  response.data.portalOtherBanner;
                // this.product_list =  response.data.menus;
                this.product_one_children_list = response.data.children
                this.product_one_list =  response.data;
                this.product_one_banner =  response.data.portalOtherBanner;
                //this.title =  response.data.portalOtherBanner;
                this.product_one_wubiao =  response.data.physicals.children;
                this.product_one_xiangguan =  response.data.applicationSolution;
                this.product_list =  response.data.menus;
            });
            // this.$get(this.apiUrl + 'home/productPage/productIndex').then((response) => {
            //     this.product_list =  response.data.portalProductFamilies;
            // });
        },
        // pro_children(id){
        //     console.log(id)
        //     let that = this
        //     that.pro_children_val = id

        //     document.querySelector('y'+id).scrollIntoView({
        //         behavior: "smooth"
        //     });
        // },
        pro_child_one(){
            let that = this
            if(that.pro_child_one_val == '1'){
                that.pro_child_one_val = '2'
            }else{
                that.pro_child_one_val = '1'
            }
        },
        pro_child_two(){
            let that = this
            if(that.pro_child_two_val == '1'){
                that.pro_child_two_val = '2'
            }else{
                that.pro_child_two_val = '1'
            }
        },
        fileurl(fileUrl){
            window.open(fileUrl,"_blank");
        }
    },
    watch:{
    '$route'(val, from) {//监听到路由（参数）改变
            this.id = val.query.id;
        //this.title = val.query.title;
        this.$post(this.apiUrl + 'home/productPage/details',{id:this.id}).then((response) => {
            this.product_one_children_list = response.data.children
            this.product_one_list =  response.data;
            this.product_one_banner =  response.data.portalOtherBanner;
            this.product_one_wubiao =  response.data.physicals.children;
            this.product_one_xiangguan =  response.data.applicationSolution;
            this.product_list =  response.data.menus;
        });
        // this.$get(this.apiUrl + 'home/productPage/productIndex').then((response) => {
        //     this.product_list =  response.data.portalProductFamilies;
        // });
    }
    },
    // beforeRouteEnter(to, from, next) {
        
    //     if(from.name=='product_two'){
    //         to.meta.isBack=true;
    //     }
    //     next();
    // },
    // activated() {
    //     alert(this.$route.meta.isBack)
    //     if(!this.$route.meta.isBack){
    //         this.$post(this.apiUrl + 'home/productPage/details',{id:this.id,title:this.title}).then((response) => {
    //             this.product_one_children_list = response.data.children
    //             this.product_one_list =  response.data;
    //             this.product_one_banner =  response.data.portalOtherBanner;
    //             this.product_one_wubiao =  response.data.physicals.children;
    //             this.product_one_xiangguan =  response.data.applicationSolution;
    //             this.product_list =  response.data.menus;
    //         });

    //         this.$get(this.apiUrl + 'home/productPage/productIndex').then((response) => {
    //             this.nav_list =  response.data.portalProductFamilies;
    //         });
    //         // this.upurl = this.apiUrl
    //         // this.Authorization = 'Bearer ' + localStorage.getItem('token')
    //         this.$route.meta.isBack=false
    //         // 恢复成默认的false，避免isBack一直是true，导致每次都获取新数据
    //         this.isFirstEnter=false;
    //     }
    // },
    created() {
        this.id = this.$route.query.id;
        //this.title = this.$route.query.title;
        this.isFirstEnter=true;
        // alert(this.title)
        this.$post(this.apiUrl + 'home/productPage/details',{id:this.id}).then((response) => {
            this.product_one_children_list = response.data.children
            this.product_one_list =  response.data;
            this.product_one_banner =  response.data.portalOtherBanner;
            this.product_one_wubiao =  response.data.physicals.children;
            this.product_one_xiangguan =  response.data.applicationSolution;
            this.product_list =  response.data.menus;
        });

        this.$get(this.apiUrl + 'home/productPage/productIndex').then((response) => {
            this.nav_list =  response.data.portalProductFamilies;
        });
        // this.$get(this.apiUrl + 'home/productPage/productIndex').then((response) => {
        //     this.product_list =  response.data.portalProductFamilies;
        // });
    },
}
</script>

<style lang="less" scoped>
    a{
        text-decoration:none;
    }
    .y_fw_sales_1{
        width: 100%;
    }
    .y_fw_sales_2{
        width: 100%;
        position: relative;
        height: 675px;
    }
    .y_fw_sales_2 img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .y_fw_sales_3{
        position: absolute;
        width: 100%;
        text-align: center;
        top: 40%;
        transform: translate(0%,-50%);
    }
    .y_fw_sales_3 h2{
        font-size: 60px;
        color: #fff;
        margin-bottom: 40px;
    }
    .y_fw_sales_3 span{
        width: 50px;
        height: 2px;
        background: #fff;
        display: inline-block;
    }
    .y_fw_sales_4{
        width: 100%;
        height: 80px;
        box-shadow: 0 0 20px 1px #eee;
    }
    .y_fw_sales_8{
        display: flex;
        justify-content: space-between;
        max-width: 1420px;
        width: 100%;
        height: 100%;
        margin: 0px auto;
    }
    .y_fw_sales_5{
        display: flex;
        justify-content: flex-start;
        align-content: center;
    }
    .y_fw_sales_6{
        width: 80px;
        height: 100%;
        border-left: 1px solid #eee;
        border-right: 1px solid #eee;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .y_fw_sales_7{
        display: flex;
        height: 100%;
        justify-content: flex-start;
        align-items: center;
    }
    .y_fw_sales_7 a{
        font-size: 14px;
        color: #3A3A3C;
        padding: 0px 20px;
        height: 100%;
        line-height: 80px;
    }
    .y_fw_sales_7 img{
        width: 6px;
        height: 12px;
        display: inline-block;
    }
    .y_fw_sales_9{
        max-width: 550px;
        width: 100%;
        height: 100%;
    }
    .y_fw_sales_9 .swiper-container{
        height: 100%;
        width: 100%;
    }
    .y_fw_sales_9 .swiper-slide{
        text-align: center;
   
    }
    .y_fw_sales_9 .swiper-container a{
        line-height: 80px;
        display: inline-block;
        font-size: 14px;
        color: #3A3A3C;
        position: relative;
    }
    .y_swiper_active{
        color: #ED6C00 !important;
    }
    .y_swiper_active::after{
        width: 100%;
        position: absolute;
        bottom: 0px;
        height: 3px;
        background: #ED6C00;
        content: '';
        left: 0px;
    }
    .y_fw_sales_9 .swiper-button-next{
        width: 10px;
        height: 18px;
        right: 0px;
        background: none;
        margin-top: -10px;
    }
    .y_fw_sales_9 .swiper-button-prev{
        width: 10px;
        height: 18px;
        left: 0px;
        background: none;
        margin-top: -10px;
    }
    

    .y_aboutbw_1{
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    .y_aboutbw_1 p{
        line-height: 80px;
        display: inline-block;
        font-size: 14px;
        color: #3A3A3C;
        position: relative;
        margin: 0px 35px;
    }
    .y_aboutbw_1 a{
        line-height: 80px;
        display: inline-block;
        font-size: 14px;
        color: #3A3A3C;
        position: relative;
        margin: 0px 35px;
    }
    // 产品详情 1
    .y_product_one_1{
        max-width: 1420px;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: left;
        top: 55%;
        h3{
            font-size: 30px;
            color: #fff;
            margin-bottom: 25px;
            font-weight: 300;
        }
    }
    // .y_product_one_2{
    //     max-width: 1420px;
    //     width: 100%;
    //     margin: 0 auto;
    //     padding: 90px 0px 110px;
    // }
    .y_product_one_3{
        img{
            max-width: 100%;
        }
    }
    
    .y_product_one_3 /deep/ img{
        max-width: 100%;
    }
    .y_product_one_4{
        width: 100%;
        margin-top: 80px;
        display: flex;
        justify-items: flex-start;
        flex-wrap: wrap;
        .y_product_one_5{
            width: 32%;
            margin-right: 2%;
            margin-bottom: 30px;
            border: 1px solid transparent;
            transition: ease 1s all;
            display: block;
            box-sizing: border-box;
            .y_product_one_6{
                width: 100%;
                height: 280px;
                display: flex;
                justify-content: center;
                align-items: center;
                background: #e2e2e2;
                transition: ease 1s all;
                img{
                    max-width: 100%;
                    max-height: 100%;
                    // width: 100%;
                    object-fit: contain;
                    display: inline-block;
                }
            }
            .y_product_one_7{
                width: 100%;
                height: 80px;
                background: #fff;
                transition: ease 1s all;
                h2{
                    padding: 10px 30px;
                    line-height: 30px;
                    align-items: center;
                    min-height: 80px;
                    font-size: 16px;
                    color: #3A3A3C;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 3;
                    overflow: hidden;
                    transition: ease 1s all;
                    font-weight: 300;
                    display: flex;
                    box-sizing: border-box;
                }
            }
        }
        .y_product_one_5:hover{
            transition: ease 1s all;
            border: 1px solid #ED6C00;
            .y_product_one_6{
                background: #fff;
                transition: ease 1s all;
            }
            .y_product_one_7{
                background: #ED6C00;
                transition: ease 1s all;
                h2{
                    transition: ease 1s all;
                    color: #fff;
                }
            }
        }
    }

    .y_product_one_4 .y_product_one_5:nth-child(3n){
        margin-right: 0%;
    }
    .y_product_one_8{
        width: 100%;
        margin-top: 25px;
    }
    .y_product_one_8_one{
        width: 100%;
        margin-top: 25px;
        .y_product_one_12{
            display: none;
        }
        .y_product_one_9{
            cursor: pointer;
            .y_product_one_11{
                img:nth-child(2){
                    display: none;
                }
            }
        }
    }
    .y_product_one_8_two{
        width: 100%;
        margin-top: 25px;
        .y_product_one_12{
            display: none;
        }
        .y_product_one_9{
            cursor: pointer;
            .y_product_one_11{
                img:nth-child(2){
                    display: none;
                }
            }
        }
    }
    .y_product_one_8_active{
        .y_product_one_12{
            display: block;
        }
        .y_product_one_9{
            .y_product_one_11{
                img:nth-child(1){
                    display: none;
                }
                img:nth-child(2){
                    display: block;
                }
            }
        }
    }
    .y_product_one_9{
        width: 100%;
        background: #fff;
        box-shadow: 0 0 10px 1px #eee;
        padding: 0px 20px;
        height: 70px;
        display: flex;
        justify-content: space-between;
        .y_product_one_10{
            h2{
                font-size: 18px;
                color: #3A3A3C;
                position: relative;
                line-height: 70px;
                padding-left: 20px;
            }
            h2::after{
                width: 4px;
                height: 16px;
                top: 50%;
                position: absolute;
                content: '';
                transform: translate(-50%, -50%);
                background: #ED6C00;
                left: 0px;
            }
        }
        .y_product_one_11{
            display: flex;
            height: 100%;
            justify-content: flex-end;
            align-items: center;
            img{
                width: 15px;
                display: inline-block;
            }
        }
        
    }
    .y_product_one_12{
        width: 100%;
        background: #f6f7fb;
        padding: 60px 40px;
        margin-top: 20px;
        .y_product_one_13{
            width: 100%;
            h2{
                font-size: 18px;
                color: #ED6C00;
                
            }
            .y_product_one_14{
                margin-top: 20px;
                p{
                    font-size: 16px;
                    color: #3A3A3C;
                    line-height: 28px;
                }
            }
        }
        .y_product_one_15{
            width: 100%;
            margin-top: 35px;
            h2{
                font-size: 18px;
                color: #3A3A3C;
                position: relative;
                padding-left: 20px;
            }
            h2::after{
                width: 0;
                height: 0;
                border-top: 10px solid #ED6C00;
                border-right: 7px solid transparent;
                border-left: 7px solid transparent;
                position: absolute;
                content: '';
                left: 0px;
                top: 50%;
                transform: translate(0%,-50%) rotate(-90deg);
            }
            .y_product_one_16{
                width: 100%;
                margin-top: 20px;
                p{
                    font-size: 16px;
                    color: #3A3A3C;
                    line-height: 30px;
                    position: relative;
                    padding-left: 35px;
                }
                p::after{
                    width: 7px;
                    height: 7px;
                    border-radius: 50px;
                    background: #3A3A3C;
                    position: absolute;
                    content: '';
                    left: 20px;
                    top: 50%;
                    transform: translate(-50%, -50%);
                }
            }
        }
    }
    .y_product_one_17{
        margin-top: 60px;
        width: 100%;
    }
    .y_product_one_19{
        width: 100%;
        margin-bottom: 40px;
    }
    .y_product_one_20{
        width: 100%;
        h2{
            font-size: 18px;
            color: #3A3A3C;
            position: relative;
            padding-left: 20px;
        }
        h2::after{
            width: 0;
            height: 0;
            border-top: 10px solid #ED6C00;
            border-right: 7px solid transparent;
            border-left: 7px solid transparent;
            position: absolute;
            content: '';
            left: 0px;
            top: 50%;
            transform: translate(0%, -50%) rotate(-90deg);
        }
    }
    .y_product_one_21{
        padding: 40px;
    }
    .y_product_one_22{
        width: 100%;
        // border: 1px solid #ebebeb;
        margin-top: 23px;
        .y_product_one_23{
            background: #f9f9f9;
            width: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border: 1px solid #ebebeb;
            height: 100px;
            h2{
                font-weight: 400;
            }
            .y_product_one_24{
                width: 485px;
                height: 100%;
                display: flex;
                align-items: center;
                h2{
                    font-size: 16px;
                    color: #3A3A3C;
                    padding-left: 20px;
                    
                }
            }
            .y_product_one_25{
                flex: 1;
                height: 100%;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                min-width: 400px;
                .y_product_one_26{
                    width: 100%;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    height: 50px;
                    border-top: 1px solid #ebebeb;
                    h2{
                        flex: 1;
                        font-size: 16px;
                        color: #3A3A3C;
                        padding-left: 20px;
                        border-right: 1px solid #ebebeb;
                    }
                    h2:nth-last-child(1){
                        border-right:none;
                    }
                    h2:nth-child(2){
                        flex: 2
                    }
                }
            }
            .y_product_one_25>h2{
                width: 100%;
                font-size: 16px;
                color: #3A3A3C;
                padding-left: 20px;
                height: 50px;
                line-height: 50px;
            }
            .y_product_one_27{
                width: 132px;
                height: 100%;
                min-width: 132px;
                // min-width: none;
                display: flex;
                justify-items: center;
                align-items: center;
                h2{
                    font-size: 16px;
                    color: #3A3A3C;
                    padding-left: 20px;
                }
            }
        }
        .y_product_one_23>div{
            border-right: 1px solid #ebebeb;
        }
        .y_product_one_23>div:nth-last-child(1){
            border-right:none;
        }
    }

    .y_product_one_28{
        width: 100%;
        background: #fff;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border: 1px solid #ebebeb;
        border-top: none;
        height: 120px;
    }
    .y_product_one_28>div{
        border-right: 1px solid #ebebeb;
        height: 100%;
    }
    .y_product_one_28>div:nth-last-child(1){
        border-right: none;
    }
    .y_product_one_29{
        width: 485px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .y_product_one_30{
            width: 90px;
            height: 90px;
            background: #e2e2e2;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: 10px;
            img{
                max-width: 86px;
                max-height: 86px;
                object-fit: cover;
                display: inline-block;
            }
        }
        .y_product_one_31{
            flex: 1;
            padding: 0px 30px 0px 20px;
            height: 100%;
            display: flex;
            align-content: center;
            flex-wrap: wrap;
            .y_product_one_32{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                width: 100%;
                .y_product_one_33{
                    width: 12px;
                    margin-right: 10px;
             
                    img{
                        width: 100%;
                        object-fit: cover;
                        display: inline-block;
                    }
                }
                .y_product_one_34{
                    h2{
                        font-size: 18px;
                        color: #ED6C00;
                    }
                    
                }
            }
            .y_product_one_39{
                width: 100%;
                margin-top: 10px;
                p{
                    font-size: 14px;
                    color: #aaa;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    line-height: 24px;
                }
            }
        }
    }   
    .y_product_one_35{
        flex: 1;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        min-width: 400px;
        p:nth-child(1){
            border-left: 1px solid #ebebeb;
        }
        p:nth-child(2){
           flex: 2;
        }
      
        p{
            flex: 1;
            border-right: 1px solid #ebebeb;
            height: 100%;
            font-size: 16px;
            color: #636366;
            padding-left: 15px;
            display: flex;
            align-items: center;
            word-break: break-all;
        }
        p:nth-last-child(1){
            border-right: none;
        }
    }
    .y_product_one_36{
        width: 132px;
        min-width: 132px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        .y_product_one_37{
            width: 27px;
            margin-right: 5px;
            img{
                width: 100%;
                display: inline-block;
            }
        }
        .y_product_one_38{
            p{
                font-size: 14px;
                color: #ec6d00;
            }
        }
    }

    .y_product_one_40{
        width: 100%;
        margin-top: 70px;
    }
    .y_product_one_41{
        width: 100%;
        text-align: center;
        h2{
            font-size: 25px;
            color: #000;
        }
    }
    .y_product_one_42{
        width: 100%;
        margin-top: 40px;
        display: flex;
        justify-items: flex-start;
    }
    .y_product_one_42 .y_product_one_43:nth-child(n+4){
        display: none;
    }
    .y_product_one_43{
        width: 32%;
        height: 260px;
        margin-right: 2%;
        position: relative;
    }
    .y_product_one_42 .y_product_one_43:nth-child(3n){
        margin-right: 0%;
    }
    .y_product_one_44{
        width: 100%;
        height: 100%;
        img{
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: inline-block;
        }
    }
    .y_product_one_45{
        width: 100%;
        height: 100%;
        position: absolute;
        top:0px;
        left: 0px;
        background: linear-gradient(to top, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
        z-index: 1;
    }
    .y_product_one_46{
        position: absolute;
        left: 0px;
        bottom: 0px;
        width: 100%;
        height: 35%;
        display: flex;
        align-content: center;
        flex-wrap: wrap;
        z-index: 2;
        padding: 0px 20px;
        h2{
            width: 100%;
            color: #fff;
            font-size: 18px;
        }
        .y_product_one_47{
            width: 100%;
            img{
                width: 48px;
                object-fit: cover;
                display: inline-block;
            }
        }
    }

    .y_product_one_12 /deep/ img{
        max-width: 100%;
    }


    // @media screen and (max-width: 1500px) {
    //     .y_product_one_2{
    //         padding: 50px 20px;
    //         max-width: 1440px;

    //     }
    //     .y_product_one_4{
    //         margin-top: 40px;
    //     }
    // }


       
.proa{
    width: 100%;
    display: flex;
    padding: 45px 0;
    padding-bottom: 100px;

    .proaleft{
        width: 25%;

        .proalm{
            padding: 0 30px;
            border-bottom: 20px;
            transition: all 0.3s ease;
            .proalh3 {
                display: none;
            }
            .proalul {
                padding: 10px;
                box-shadow: 0 5px 15px rgb(0 0 0 / 5%);
                background: #fff;

                a {
                    padding: 12px 20px;
                    border-bottom: 1px solid #cfcfcf;
                    display: block;
                    text-decoration: none;
                }

                a.no h5 i {
                    right: 0;
                    left: auto;
                }
                a.no h5 i:before {
                    background: url(../assets/images/pdficon2.png) center no-repeat;
                    left: auto;
                    right: 0;
                }

                h5 {
                    font-size: 16px;
                    color: #13293a;
                    position: relative;
                    cursor: pointer;
                    i {
                        vertical-align: middle;
                        font-style: normal;
                        position: absolute;
                        width: 9px;
                        height: 9px;
                        display: inline-block;
                        left: 0;
                        top: 3px;
                    }
                    i:before {
                        background: url(../assets/images/prosub11.png) center no-repeat;
                    }
                    i:after {
                        background: url(../assets/images/prosub12.png) center no-repeat;
                        opacity: 0;
                    }

                    i:before, i:after {
                        position: absolute;
                        content: '';
                        left: -16px;
                        top: 6px;
                        width: 100%;
                        height: 100%;
                    }
                }
                
            }
        }
    }

    .y_product_one_2{
        padding-right: 5%;
        padding-top: 0;
        width: 75%;
    }

    .idgua1{
        position: static; 
        left: auto; 
    }

    .idgua2{
        position: fixed; 
        width: 25%;
        left: 0;
        top: 125px ;
        bottom: 1000px;
    }
}

.proar1p4th5:before {
    position: absolute;
    content: '';
    left: 0;
    top: 10px;
    width: 6px;
    height: 6px;
    background: #eb6d1f;
    border-radius: 50%;
    -webkit-border-radius: 50%;
}

.proar1p4th5 {
    font-size: 18px;
    padding-left: 15px;
    position: relative;
    color: #eb6d1f;
}

.zflprotitle{
    border: 1px solid #ebebeb;
    background: #fff;
    height: 40px;
    line-height: 40px;
    padding-left: 20px;
    color: #ec6d00;
    border-top: 0;
}
</style>
